import { render, staticRenderFns } from "./IconTooltip.vue?vue&type=template&id=96a1c960&scoped=true"
import script from "./IconTooltip.vue?vue&type=script&lang=js"
export * from "./IconTooltip.vue?vue&type=script&lang=js"
import style0 from "./IconTooltip.vue?vue&type=style&index=0&id=96a1c960&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96a1c960",
  null
  
)

export default component.exports